"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfGetOfferDto = instanceOfGetOfferDto;
exports.GetOfferDtoFromJSON = GetOfferDtoFromJSON;
exports.GetOfferDtoFromJSONTyped = GetOfferDtoFromJSONTyped;
exports.GetOfferDtoToJSON = GetOfferDtoToJSON;
exports.GetOfferDtoToJSONTyped = GetOfferDtoToJSONTyped;
var OfferUnderListingDto_1 = require("./OfferUnderListingDto");
var GetOfferPartyDto_1 = require("./GetOfferPartyDto");
var GetOriginalOfferDto_1 = require("./GetOriginalOfferDto");
var GetOfferDetailsDto_1 = require("./GetOfferDetailsDto");
var GetPaymentReceiptDto_1 = require("./GetPaymentReceiptDto");
/**
 * Check if a given object implements the GetOfferDto interface.
 */
function instanceOfGetOfferDto(value) {
    if (!('offer' in value) || value['offer'] === undefined)
        return false;
    if (!('buyers' in value) || value['buyers'] === undefined)
        return false;
    if (!('sellers' in value) || value['sellers'] === undefined)
        return false;
    if (!('listing' in value) || value['listing'] === undefined)
        return false;
    return true;
}
function GetOfferDtoFromJSON(json) {
    return GetOfferDtoFromJSONTyped(json, false);
}
function GetOfferDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'offer': (0, GetOfferDetailsDto_1.GetOfferDetailsDtoFromJSON)(json['offer']),
        'originalOffer': json['originalOffer'] == null ? undefined : (0, GetOriginalOfferDto_1.GetOriginalOfferDtoFromJSON)(json['originalOffer']),
        'buyers': (json['buyers'].map(GetOfferPartyDto_1.GetOfferPartyDtoFromJSON)),
        'sellers': (json['sellers'].map(GetOfferPartyDto_1.GetOfferPartyDtoFromJSON)),
        'listing': (0, OfferUnderListingDto_1.OfferUnderListingDtoFromJSON)(json['listing']),
        'paymentSummary': json['paymentSummary'] == null ? undefined : (0, GetPaymentReceiptDto_1.GetPaymentReceiptDtoFromJSON)(json['paymentSummary']),
    };
}
function GetOfferDtoToJSON(json) {
    return GetOfferDtoToJSONTyped(json, false);
}
function GetOfferDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'offer': (0, GetOfferDetailsDto_1.GetOfferDetailsDtoToJSON)(value['offer']),
        'originalOffer': (0, GetOriginalOfferDto_1.GetOriginalOfferDtoToJSON)(value['originalOffer']),
        'buyers': (value['buyers'].map(GetOfferPartyDto_1.GetOfferPartyDtoToJSON)),
        'sellers': (value['sellers'].map(GetOfferPartyDto_1.GetOfferPartyDtoToJSON)),
        'listing': (0, OfferUnderListingDto_1.OfferUnderListingDtoToJSON)(value['listing']),
        'paymentSummary': (0, GetPaymentReceiptDto_1.GetPaymentReceiptDtoToJSON)(value['paymentSummary']),
    };
}
